import { CustomAccordion } from '@aibees/shared/components';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(CustomAccordion)``;

export const List = styled('ul')`
  list-style: disc;
  padding-left: 16px;
`;
export const ListItem = styled('li')``;
